import { render, staticRenderFns } from "./SimplePopUp.vue?vue&type=template&id=67325241"
import script from "./SimplePopUp.vue?vue&type=script&lang=js"
export * from "./SimplePopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports